import { render, staticRenderFns } from "./DoughnutChartNaf.vue?vue&type=template&id=2c05a74a"
import script from "./DoughnutChartNaf.vue?vue&type=script&lang=js"
export * from "./DoughnutChartNaf.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChartNaf.vue?vue&type=style&index=0&id=2c05a74a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports